export default __webpack_public_path__ + "static/media/aprimorar_item_01.f303f2ff.mp3";